<template>
  <div class="full-height col" :class="[mode.miniState ? 'bg-white reduction' : 'bg-teal-2 expansion']"
    style="overflow-x:hidden;overflow-y:auto;display: flex; flex-direction: column; justify-content: space-between;"
  >
    <div v-if="!mode.miniState" style="text-align: center;font-size: medium;margin-top: 8px;">
      {{ title1 }}
    </div>

    <q-scroll-area 
      class="col full-height"
      :class="[mode.miniState ?  'reduction-image-container' : 'expansion-image-container']"
      style="overflow-x:hidden;overflow-y:auto;flex-wrap:wrap"
    >
      <template v-for="(sampleImage, i) in images">
        <q-img
          v-if="!mode.miniState"
          :key="`sample-image-${i}`"
          :src="sampleImage.url"
          style="cursor:pointer;border-radius:5px;"
          spinner-color="secondary"
          class="shadow-2"
          :title="sampleImage.name"
          :width="imageWidthPx"
          height="100px"
          fit="contain"
          @click="listen__sample_image__onclick(sampleImage)"
        >
          <template v-slot:error>
            <div class="absolute-full flex flex-center bg-red text-white">
              불러오기 실패
            </div>
          </template>
        </q-img>
        <q-item v-else clickable v-ripple :key="`sample-icon-${i}`" @click="listen__sample_image__onclick(sampleImage)">
          <q-item-section avatar>
            <q-icon name="image" />
          </q-item-section>
        </q-item>
        <div v-if="!mode.miniState && i < images.length - 1" :key="`sample-seperator-${i}`" style="margin-bottom: 8px;"></div>
      </template>
    </q-scroll-area>

    <q-separator />
    <q-item clickable v-ripple @click="mode.miniState = !mode.miniState"  :class="[mode.miniState ? 'reduction' : 'expansion']">
      <q-item-section avatar>
        <q-icon v-if="mode.miniState == false" name="chevron_left" />
        <q-icon v-else name="chevron_right" />
      </q-item-section>
    </q-item>
  </div>
</template>

<script>
export default {
  props: [
    'title',
    'image-width',
    'images'
  ],
  data: function () {
    const Vue = this
    return {
      mode: {
        show: true,
        miniState: false
      },
      title1: Vue.title != undefined ? Vue.title : "샘플 이미지"
    }
  },
  methods: {
    listen__sample_image__onclick: async function (sampleImage) {
      const Vue = this
      this.$emit("jobstart", `${sampleImage.name} 이미지를 다운받고 있습니다.`)
      let file
      try {
        file = await Vue.convertURLtoFile(sampleImage.url)
      } catch (err) {
        this.$emit("joberror", {color: 'red', message: '이미지를 받아오는데 실패하였습니다'})
        return
      }
      this.$emit("jobdone", {file, sampleImage})
    },
    convertURLtoFile: async function(url) {
      const response = await fetch(url)
      const data = await response.blob()
      const ext = url.split(".").pop()
      const filename = url.split("/").pop()
      const metadata = { type: `image/${ext}` }
      return new File([data], filename, metadata)
    }
  },
  computed: {
    imageWidthPx: function () {
      // return this.imageWidth == null ? null : this.imageWidth + 'px'
      return '100px'
    },
    classObject: function () {
      return {
        expansion: !this.mode.miniState,
        reduction: this.mode.ministate
      }
    }
  }
}
</script>


<style scoped>

.expansion {
  width: 125px;
}

.reduction {
  width: 56.2px;
}

.expansion-image-container {
  width: 125px;
  padding: 12px;
}

.reduction-image-container {
  width: 56.2px;
  padding-top: 8px;
}

</style>